import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    class: 'ineligible',
    field: 'edMonthly_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    type: 'info',
    isLast: true,
    reject: true,
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'edMonthly_didNotConsent',
    label: 'We need your consent to continue',
    subLabel:
      'You did not agree to the terms shown on the previous step. Without that consent, we cannot move forward with your visit or prescribe treatment.',
    type: 'info',
    isLast: true,
    reject: true,
    extras: { sendToBeluga: false },
    answer: {}
  },
  {
    field: 'edMonthly_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    label: 'What is your height in feet and inches?',
    field: 'edMonthly_height',
    type: 'info',
    answer: {
      name: 'edMonthly_height',
      type: 'text',
      placeholder: 'Feet and inches'
    }
  },
  {
    label: 'What is your weight in pounds?',
    field: 'edMonthly_weight',
    type: 'info',
    answer: {
      name: 'edMonthly_weight',
      type: 'text',
      placeholder: 'Pounds'
    }
  },
  {
    label: 'What was your sex assigned at birth?',
    field: 'edMonthly_sexAtBirth',
    extras: {
      sendToBeluga: false
    },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edMonthly_sexAtBirth_male',
          value: 'Male'
        },
        {
          key: 'edMonthly_sexAtBirth_female',
          value: 'Female'
        }
      ]
    }
  },
  {
    label:
      'Have there been any health changes, medication changes, ED visits or hospitalizations since your last check-in?',
    field: 'edMonthly_healthChanges',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edMonthly_healthChanges_yes',
          value: 'Yes'
        },
        {
          key: 'edMonthly_healthChanges_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about the changes in your health',
    field: 'edMonthly_healthChanges_details',
    type: 'info',
    answer: {
      name: 'edMonthly_healthChanges_details',
      type: 'text',
      placeholder: 'Health changes details'
    }
  },
  {
    label: 'How are you doing on the current medication?',
    field: 'edMonthly_medicationStatus',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edMonthly_medicationStatus_well',
          value: 'Well'
        },
        {
          key: 'edMonthly_medicationStatus_notWell',
          value: 'Not well'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about what you are experiencing',
    field: 'edMonthly_medicationStatus_details',
    type: 'info',
    answer: {
      name: 'edMonthly_medicationStatus_details',
      type: 'text',
      placeholder: 'Medication experience details'
    }
  },
  {
    label: 'Have you had any side effects from the current medication?',
    field: 'edMonthly_sideEffects',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edMonthly_sideEffects_yes',
          value: 'Yes'
        },
        {
          key: 'edMonthly_sideEffects_no',
          value: 'No'
        }
      ]
    }
  },
  {
    label: 'Please tell us more about the side effects you are experiencing',
    field: 'edMonthly_sideEffects_details',
    type: 'info',
    answer: {
      name: 'edMonthly_sideEffects_details',
      type: 'text',
      placeholder: 'Side effects details'
    }
  },
  {
    label: 'What other information or questions do you have for the doctor?',
    field: 'edMonthly_otherInformation',
    type: 'info',
    answer: {
      name: 'edMonthly_otherInformation',
      type: 'text',
      placeholder: 'Additional information'
    }
  },
  {
    label: 'Consent (PDE5 Inhibitor Treatment):',
    educationalSlide: `You have been diagnosed with or have reported that you have a known diagnosis of organic or psychogenic (situational) erectile dysfunction—a condition characterized by the inability to achieve or maintain an erection sufficient for satisfactory sexual performance. Phosphodiesterase Type 5 Inhibitors (PDE5 inhibitors) are medications prescribed to treat this condition by enhancing erectile function.\n\nCommon PDE5 inhibitors include Sildenafil (Viagra), Tadalafil (Cialis), Vardenafil (Levitra), and Avanafil (Stendra). These medications work by increasing blood flow to the penis during sexual stimulation.\n\nThe use of PDE5 inhibitors may:\n\n- Improve your ability to achieve and maintain an erection\n- Enhance sexual performance and satisfaction\n- Improve your quality of life and personal relationships\n\nWhile PDE5 inhibitors are generally well-tolerated, possible side effects may include:\n\n- Headache\n- Flushing\n- Indigestion or upset stomach\n- Nasal congestion\n- Dizziness or lightheadedness\n- Visual disturbances (such as blurred vision or changes in color perception)\n- Back pain or muscle aches (more common with Tadalafil)\n- Hearing loss or ringing in the ears (rare)\n- Priapism (a prolonged erection lasting more than four hours)\n- Allergic reactions (rash, itching, or swelling)\n\n**Do not use PDE5 inhibitors if you:**\n\n- Take nitrates for chest pain (angina)\n- Use recreational drugs called "poppers" (amyl nitrate or nitrite)\n- Have severe heart or liver problems\n- Have recently had a stroke or heart attack\n- Have low blood pressure\n\n**Alternative treatments include:**\n\n- **Lifestyle changes:**\n    - Exercise\n    - Weight loss\n    - Quitting smoking\n    - Reducing alcohol intake\n- **Psychotherapy or counseling** for psychological causes of erectile dysfunction\n- **Vacuum erection devices**, which are mechanical pumps to induce erections\n- **Penile injections or suppositories**, where medications are administered directly to the penis\n- **Hormone therapy** if low testosterone levels are contributing to erectile dysfunction\n- **Surgical options** like penile implants or vascular surgery\n\nI understand the potential benefits, risks, and side effects of using PDE5 inhibitors. I have been informed about alternative treatment options. I agree to inform my healthcare provider of any side effects or adverse reactions I may experience. I understand that this consent is voluntary and that I can withdraw from treatment at any time.\n\nBy selecting below, I consent to the use of PDE5 inhibitors for the treatment of my erectile dysfunction.`,
    field: 'edMonthly_consent',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'edMonthly_consent_disagree',
          class: 'option-decline',
          value: 'I have read the information and I DO NOT wish to proceed'
        },
        {
          key: 'edMonthly_consent_agree',
          class: 'option-consent',
          value:
            'I have read and understand the information and I wish to proceed'
        }
      ]
    }
  }
];

export default questionsModels;

// 448#EDVISIT@1738011532434
// {
//   "formObj": {
//       "consentsSigned": true,
//       "firstName": "Ibrahim",
//       "lastName": "M",
//       "dob": "12/12/1999",
//       "phone": "6572392082",
//       "email": "ibrahim@appgen.ca",
//       "sex": "Male",
//       "address": "asd asd",
//       "city": "asd",
//       "state": "NY",
//       "zip": "10004",
//       "selfReportedMeds": "asd; asd",
//       "allergies": "Sulfa drugs",
//       "medicalConditions": "Heart disease; Irregular heartbeat",
//       "patientPreference": [
//           {
//               "name": "Sildenafil 25mg",
//               "strength": "0",
//               "quantity": "1",
//               "refills": "0",
//               "medId": "i4gbeBWSZBW7VfxRUQmkqlRDgImCzww5"
//           }
//       ],
//       "Q1": "What is your height in feet and inches?",
//       "A1": "123",
//       "Q2": "What is your weight in pounds?",
//       "A2": "123",
//       "Q3": "Have there been any health changes, medication changes, ED visits or hospitalizations since your last check-in? POSSIBLE ANSWERS: Yes; No",
//       "A3": "Yes",
//       "Q4": "Please tell us more about the changes in your health",
//       "A4": "123",
//       "Q5": "How are you doing on the current medication? POSSIBLE ANSWERS: Well; Not well",
//       "A5": "Not well",
//       "Q6": "Please tell us more about what you are experiencing",
//       "A6": "123",
//       "Q7": "Have you had any side effects from the current medication? POSSIBLE ANSWERS: Yes; No",
//       "A7": "Yes",
//       "Q8": "Please tell us more about the side effects you are experiencing",
//       "A8": "123",
//       "Q9": "What other information or questions do you have for the doctor?",
//       "A9": "123",
//       "Q10": "Consent (PDE5 Inhibitor Treatment):You have been diagnosed with or have reported that you have a known diagnosis of organic or psychogenic (situational) erectile dysfunction—a condition characterized by the inability to achieve or maintain an erection sufficient for satisfactory sexual performance. Phosphodiesterase Type 5 Inhibitors (PDE5 inhibitors) are medications prescribed to treat this condition by enhancing erectile function.\n\nCommon PDE5 inhibitors include Sildenafil (Viagra), Tadalafil (Cialis), Vardenafil (Levitra), and Avanafil (Stendra). These medications work by increasing blood flow to the penis during sexual stimulation.\n\nThe use of PDE5 inhibitors may:\n\n- Improve your ability to achieve and maintain an erection\n- Enhance sexual performance and satisfaction\n- Improve your quality of life and personal relationships\n\nWhile PDE5 inhibitors are generally well-tolerated, possible side effects may include:\n\n- Headache\n- Flushing\n- Indigestion or upset stomach\n- Nasal congestion\n- Dizziness or lightheadedness\n- Visual disturbances (such as blurred vision or changes in color perception)\n- Back pain or muscle aches (more common with Tadalafil)\n- Hearing loss or ringing in the ears (rare)\n- Priapism (a prolonged erection lasting more than four hours)\n- Allergic reactions (rash, itching, or swelling)\n\n**Do not use PDE5 inhibitors if you:**\n\n- Take nitrates for chest pain (angina)\n- Use recreational drugs called \"poppers\" (amyl nitrate or nitrite)\n- Have severe heart or liver problems\n- Have recently had a stroke or heart attack\n- Have low blood pressure\n\n**Alternative treatments include:**\n\n- **Lifestyle changes:**\n    - Exercise\n    - Weight loss\n    - Quitting smoking\n    - Reducing alcohol intake\n- **Psychotherapy or counseling** for psychological causes of erectile dysfunction\n- **Vacuum erection devices**, which are mechanical pumps to induce erections\n- **Penile injections or suppositories**, where medications are administered directly to the penis\n- **Hormone therapy** if low testosterone levels are contributing to erectile dysfunction\n- **Surgical options** like penile implants or vascular surgery\n\nI understand the potential benefits, risks, and side effects of using PDE5 inhibitors. I have been informed about alternative treatment options. I agree to inform my healthcare provider of any side effects or adverse reactions I may experience. I understand that this consent is voluntary and that I can withdraw from treatment at any time.\n\nBy selecting below, I consent to the use of PDE5 inhibitors for the treatment of my erectile dysfunction. POSSIBLE ANSWERS: I have read and understand the information and I wish to proceed; I have read the information and I DO NOT wish to proceed",
//       "A10": "I have read and understand the information and I wish to proceed"
//   },
//   "pharmacyId": "29992",
//   "masterId": "448#EDVISIT@1738011532434",
//   "company": "carePortalsMandos",
//   "visitType": "ED"
// }

